
import {defineComponent} from "vue";
export default defineComponent({
    props:{
        checkedValue:{
            type:String,
            required:true
        },
        modelValue:{
            type:String,
            required:true
        }
    },
    data(){
        return {
            checked:false
        }
    },
    methods:{
        onClick(){
            this.checked = !this.checked;
            this.$emit('update:modelValue',this.checked?this.checkedValue:'inherit');
        }
    }
})
